import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import { NewsUpdateTitle } from '../../../../Utils/Constants'
import { Btn, H5, Image } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Utils'
import { Link } from 'react-router-dom'
import { newsUpdateData } from '../../../../Data/DashboardsData/DefaultData'

export default function NewsUpdate() {
    return (
        <Col xl={4} md={6} className="box-col-6">
            <Card className="news-update">
                <DropdownWithHeader headerClass='pb-0' heading={NewsUpdateTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    {newsUpdateData.map((item) => (
                        <div className={`d-flex align-items-center ${item.id === 1 ? "pt-0" : ""}`} key={item.id}>
                            <Image src={dynamicImage(`dashboard/news/${item.image}`)} alt="" />
                            <div className="flex-grow-1">
                                <Link to={`${process.env.PUBLIC_URL}/applications/social-app`}>
                                    <H5>{item.title}</H5>
                                    <span>{item.text}</span>
                                </Link>
                            </div>
                            <div className="flex-shrink-0">
                                <Btn color='transparent'>{item.time}</Btn>
                            </div>
                        </div>
                    ))}
                </CardBody>
            </Card>
        </Col>
    )
}